import {
  createExternalIdpLogin,
  listExternalIdentities,
  unlinkExternalIdentity,
  isLastSignInMethod,
  isNetworkFailure
} from './externalIdpLogin'

/**
 * Google Workspace ログインの画面側。
 *
 * 中身は {@link createExternalIdpLogin} と同じ。Microsoft との違いは
 * 呼ぶ口の名前だけで、**画面が持つ判断は増えない**。
 *
 * ■ 会社のアカウントかどうかを画面で見ない
 *
 * Google の issuer は全世界で1つなので、issuer では組織を絞れない。
 * 絞るのは IDトークンの hd（Workspace のドメイン）で、これはサーバが
 * 見る。画面がメールアドレスのドメインで判定する形にすると、
 *
 *   - 個人の Gmail を会社の人として通す
 *   - email は確認済みでないことがあり、そもそも当てにならない
 *
 * ということになる。**画面はドメインを一切見ない。**
 */

const google = createExternalIdpLogin('google', 'googleLoginAvailable')

export function isGoogleLoginAvailable () {
  return google.isAvailable()
}

export function startGoogleLogin () {
  return google.startLogin()
}

export function startGoogleLink () {
  return google.startLink()
}

export {
  listExternalIdentities,
  unlinkExternalIdentity,
  isLastSignInMethod,
  isNetworkFailure
}
